import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { Modal } from "@mui/material";
import { LuUser, LuFileCheck } from "react-icons/lu";
import { BsCardChecklist, BsPencil, BsFillTrash3Fill } from "react-icons/bs";
import Tooltip from "@mui/material/Tooltip";
import api from "../../api";
import { format, isValid, differenceInMinutes, parseISO } from "date-fns";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Input from "../form/Input";
import Dropdown from "../form/Dropdown";
import { toast } from "react-toastify";

export default function StudentsList() {
  const [selectedCollege, setSelectedCollege] = useState("all");
const [filteredStudents, setFilteredStudents] = useState([]);
  const [students, setStudents] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [modalTitle, setModalTitle] = useState("");
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editStudent, setEditStudent] = useState({ name: "", email: "", phone: "" });
    const [selectedStudentName, setSelectedStudentName] = useState("");
    const [colleges, setColleges] = useState(null);
    const safeFormat = (date, dateFormat) => {
      const parsedDate = typeof date === "string" ? parseISO(date) : new Date(date);
      return isValid(parsedDate) ? format(parsedDate, dateFormat) : "Invalid";
    };


    useEffect(() => {
      const getApiData = async () => {
        const { data } = await api.get(`${process.env.REACT_APP_API_BASE_URL}students/approved`);
        setStudents(data);
        setFilteredStudents(data); // initialize filtered data
      };
      getApiData();
    }, []);

    useEffect(() => {
      if (selectedCollege === "all") {
        setFilteredStudents(students);
      } else {
        const filtered = students.filter((stu) => stu.college?._id === selectedCollege);
        setFilteredStudents(filtered);
      }
    }, [selectedCollege, students]);


  useEffect(() => {
    const getApiData = async () => {
      try {
        const { data } = await api.get(
          `${process.env.REACT_APP_API_BASE_URL}colleges/approved`
        );
        setColleges(data);
      } catch (error) {
        toast.error("Failed to load colleges!");
      }
    };
    getApiData();
  }, []);


  useEffect(() => {
    const getApiData = async () => {
      const { data } = await api.get(`${process.env.REACT_APP_API_BASE_URL}students/approved`);
      setStudents(data);
    };
    getApiData();
  }, []);

  const handleActionClick = async (type, idOrEmail) => {
    setModalTitle(type);
    try {
      let url = "";
      if (type === "profile") url = `${process.env.REACT_APP_API_BASE_URL}students/profile/${idOrEmail}`;
      if (type === "attendance") url = `${process.env.REACT_APP_API_BASE_URL}attendance/student/${idOrEmail}`;
      if (type === "report") url = `${process.env.REACT_APP_API_BASE_URL}report/student/${idOrEmail}`;

      const { data } = await api.get(url);
      setModalContent(data || []);
      setModalOpen(true);
    } catch (error) {
      console.error("Error fetching data:", error);
      setModalContent([]);
      setModalOpen(true);
    }
  };

  const handleEditClick = (student) => {
    setEditStudent(student);
    setEditModalOpen(true);
  };

  const handleEditSubmit = async () => {
    try {
      const { _id, ...updatedFields } = editStudent;
      const { data } = await api.put(`${process.env.REACT_APP_API_BASE_URL}students/edit/${_id}`, updatedFields);
      setStudents((prev) => prev.map((stu) => (stu._id === _id ? { ...stu, ...updatedFields } : stu)));
      setEditModalOpen(false);
    } catch (err) {
      console.error("Edit error", err);
    }
  };

  const handleDeleteClick = async (studentId) => {
    if (window.confirm("Are you sure you want to delete this student?")) {
      try {
        await api.delete(`${process.env.REACT_APP_API_BASE_URL}students/delete/${studentId}`);
        setStudents((prev) => prev.filter((stu) => stu._id !== studentId));
      } catch (err) {
        console.error("Delete error", err);
      }
    }
  };
    const formatAttendanceDataForExport = (data) => {
      return data.map((attendance, index) => {
        const clockIn = new Date(attendance.clockInTime);
        const clockOut = new Date(attendance.clockOutTime);
        const totalMinutes = isValid(clockIn) && isValid(clockOut)
          ? differenceInMinutes(clockOut, clockIn)
          : 0;
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        return {
          "#": index + 1,
          Date: format(clockIn, "dd MMM yyyy"),
          "Clock In": format(clockIn, "hh:mm a"),
          "Clock Out": format(clockOut, "hh:mm a"),
          Total: `${hours}h ${minutes}m`,
        };
      });
    };
  


    const downloadAttendanceAsPDF = () => {
      const doc = new jsPDF();
      doc.text(`Attendance - ${selectedStudentName}`, 14, 10);
      const tableData = formatAttendanceDataForExport(modalContent).map((row) => Object.values(row));
      autoTable(doc, {
        head: [["#", "Date", "Clock In", "Clock Out", "Total"]],
        body: tableData,
      });
      doc.save(`${selectedStudentName.replace(/\s+/g, "_")}_attendance.pdf`);
    };
  
    const downloadAttendanceAsExcel = () => {
      const formatted = formatAttendanceDataForExport(modalContent);
      const worksheet = XLSX.utils.json_to_sheet(formatted);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Attendance");
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const fileData = new Blob([excelBuffer], { type: "application/octet-stream" });
      saveAs(fileData, `${selectedStudentName.replace(/\s+/g, "_")}_attendance.xlsx`);
    };




    const generateDateRange = (startDate, endDate) => {
      const start = new Date(startDate);
      const end = new Date(endDate);
      const dates = [];
    
      while (start <= end) {
        dates.push(new Date(start));
        start.setDate(start.getDate() + 1);
      }
    
      return dates;
    };
    
    const attendanceRangeDates = generateDateRange("2025-05-15", "2025-09-15");



    const handleStatusUpdate = async (attendanceId, newStatus) => {
      try {
        const { data } = await api.put(`${process.env.REACT_APP_API_BASE_URL}attendance/update/${attendanceId}`, {
          status: newStatus,
        });
    
        setModalContent((prev) =>
          prev.map((entry) =>
            entry._id === attendanceId ? { ...entry, status: newStatus } : entry
          )
        );
    
        toast.success("Status updated!");
      } catch (error) {
        toast.error("Failed to update status.");
        console.error("Update error:", error);
      }
    };
  const columns = [
    {
      field: "name",
      headerName: "Name",
      flex: 2,
      minWidth: 300,
      headerClassName: "custom-header",
    },
    {
      field: "phone",
      headerName: "Phone",
      flex: 3,
      minWidth: 100,
      headerClassName: "custom-header",
    },

    {
      field: "email",
      headerName: "Email",
      flex: 3,
      minWidth: 300,
      headerClassName: "custom-header",
    },

    {
      field: "actions",
      headerName: "Actions",
      flex: 2,
      minWidth: 200,
      headerClassName: "custom-header",
      renderCell: (params) => (
        <div className="flex justify-between py-4 pe-6 gap-4">
          <Tooltip title="Profile" arrow>
            <LuUser
              className="h-4 w-4 cursor-pointer hover:text-orange-500"
              onClick={() => handleActionClick("profile", params.row.email)}
            />
          </Tooltip>
          <Tooltip title="Attendance" arrow>
            <BsCardChecklist
              className="h-4 w-4 cursor-pointer hover:text-orange-500"
              onClick={() => handleActionClick("attendance", params.row.email)}
            />
          </Tooltip>
          <Tooltip title="Report" arrow>
            <LuFileCheck
              className="h-4 w-4 cursor-pointer hover:text-orange-500"
              onClick={() => handleActionClick("report", params.row._id)}
            />
          </Tooltip>
          <Tooltip title="Edit" arrow>
            <BsPencil
              className="h-4 w-4 cursor-pointer hover:text-orange-500"
              onClick={() => handleEditClick(params.row)}
            />
          </Tooltip>
          <Tooltip title="Delete" arrow>
            <BsFillTrash3Fill
              className="h-4 w-4 text-red-500 cursor-pointer hover:text-orange-500"
              onClick={() => handleDeleteClick(params.row._id)}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <div className="bg-white/5 backdrop-blur-lg rounded-2xl p-4 shadow-lg border border-white/10">
      <div className="flex justify-end mb-4 gap-4">
  <Dropdown
    id="collegeFilter"
    name="collegeFilter"
    label="Filter by College"
    value={selectedCollege}
    onChange={(e) => setSelectedCollege(e.target.value)}
    options={[
      { _id: "all", name: "All Colleges" },
      ...(colleges || []),
      
    ]}
    className="block w-full px-4 py-2 mt-1 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-400"
    
  />
</div>
      <DataGrid
        rows={filteredStudents || []} // updated
        columns={columns}
        getRowId={(row) => row._id}
        initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
        pageSizeOptions={[10]}
        sx={{
          // Glassy root container
    backgroundColor: "rgba(255, 255, 255, 0.03)",
    border: "none",
    borderRadius: 3,
    backdropFilter: "blur(8px)",
  
    // Top header row
    "& .MuiDataGrid-columnHeaders": {
      backgroundColor: "rgba(255, 255, 255, 0.08)",
      backdropFilter: "blur(12px)",
      borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
    },
  
    // Footer container (bottom row)
    "& .MuiDataGrid-footerContainer": {
      backgroundColor: "rgba(255,255,255,0.05)",
      borderTop: "1px solid rgba(255,255,255,0.1)",
      backdropFilter: "blur(10px)",
    },
  
    // Ensure rows have no override from CSS variable
    "& .MuiDataGrid-row": {
      backgroundColor: "transparent !important",
    },
  
    // Optional: override containerBackground if needed
    "--DataGrid-containerBackground": "transparent",
        }}
      />

      {/* Modal for Profile / Attendance / Report */}
      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
      >
        <div className="bg-white rounded-lg shadow-lg w-full max-w-5xl max-h-[90vh] overflow-hidden">
          <div className="flex items-center justify-between px-4 pt-2 pb-2 border-b">
            <h2 className="text-xl font-semibold capitalize">{modalTitle}</h2>
            <button className="p-2 rounded-full hover:bg-gray-200" onClick={() => setModalOpen(false)}>
              &#10005;
            </button>
          </div>
          <div className="px-4 pt-2 pb-4 overflow-auto max-h-[calc(90vh-8rem)]">

             {/* Profile Modal Content */}
             {modalTitle === "profile" && modalContent ? (
  <div className="space-y-4">
    <h3 className="text-lg font-semibold">Profile</h3>
    <div className="space-y-2">
      <p><strong>Name:</strong> {modalContent?.name}</p>
      <p><strong>Email:</strong> {modalContent?.email}</p>
      <p><strong>Phone:</strong> {modalContent?.phone}</p>
      <p><strong>College:</strong> {modalContent?.college?.name}</p>
      <p><strong>Year:</strong> {modalContent?.year}</p>
      <p><strong>Branch:</strong> {modalContent?.branch}</p>
      <p><strong>Course:</strong> {modalContent?.course}</p>
      <p><strong>Approved:</strong> {modalContent?.approved ? "Yes" : "No"}</p>
    </div>
  </div>
) : (
  <p></p>
)}




            {/* Attendance Table */}
            {modalTitle === "attendance" && Array.isArray(modalContent) && (
  modalContent.length > 0 ? (
    <div className="overflow-x-auto">
      <div className="flex gap-3 mb-4">
        <button onClick={downloadAttendanceAsPDF} className="px-4 py-1 text-sm bg-red-500 text-white rounded hover:bg-red-600">Download PDF</button>
        <button onClick={downloadAttendanceAsExcel} className="px-4 py-1 text-sm bg-green-500 text-white rounded hover:bg-green-600">Download Excel</button>
      </div>

      {/* Attendance Table */}
      <table className="min-w-full text-sm border mb-6">
        <thead className="bg-gray-100 text-gray-600">
          <tr>
            <th className="px-2 py-2 border">Sr.No</th>
            <th className="px-2 py-2 border">Date</th>
            <th className="px-2 py-2 border">Clock In</th>
            <th className="px-2 py-2 border">Clock Out</th>
            <th className="px-2 py-2 border">Total</th>
            <th className="px-2 py-2 border">Status</th>
            <th className="px-2 py-2 border">Action</th>
          </tr>
        </thead>
        <tbody>
          {modalContent?.map((attendance, index) => {
            const clockIn = new Date(attendance?.clockInTime);
            const clockOut = new Date(attendance?.clockOutTime);
            const totalMinutes = isValid(clockIn) && isValid(clockOut) ? differenceInMinutes(clockOut, clockIn) : 0;
            const hours = Math.floor(totalMinutes / 60);
            const minutes = totalMinutes % 60;
            const currentStatus = attendance?.status || "Present";

            return (
              <tr key={index} className="hover:bg-gray-50">
                <td className="px-2 py-2 border" align="center">{index + 1}</td>
                <td className="px-2 py-2 border" align="center">{safeFormat(clockIn, "dd MMM yyyy")}</td>
                <td className="px-2 py-2 border" align="center">{safeFormat(clockIn, "hh:mm a")}</td>
                <td className="px-2 py-2 border" align="center">{safeFormat(clockOut, "hh:mm a")}</td>
                <td className="px-2 py-2 border" align="center">{`${hours}h ${minutes}m`}</td>
                <td className="px-2 py-2 border text-center">
                  <select
                    value={currentStatus}
                    className="border px-2 py-1 rounded"
                    onChange={(e) => handleStatusUpdate(attendance._id, e.target.value)}
                  >
                    <option value="Present">Present</option>
                    <option value="Absent">Absent</option>
                  </select>
                </td>
                <td className="px-2 py-2 border text-center">
                  <button
                    className="bg-blue-500 text-white px-3 py-1 text-sm rounded hover:bg-blue-600"
                    onClick={() => handleStatusUpdate(attendance._id, attendance.status)}
                  >
                    Save
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {/* ✅ Add this calendar block below the table */}
      <div className="mt-6">
        <h3 className="text-lg font-semibold mb-2">Calendar View</h3>
        <div className="grid grid-cols-7 gap-1 text-xs text-center">
          {attendanceRangeDates.map((date, index) => {
            const formatted = format(date, "yyyy-MM-dd");
            const record = modalContent.find((entry) =>
              format(new Date(entry.clockInTime), "yyyy-MM-dd") === formatted
            );
            const status = record?.status || "Absent";

            return (
              <div
                key={index}
                className={`border p-1 rounded ${
                  status === "Present" ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"
                }`}
              >
                <div className="font-medium">{format(date, "dd MMM")}</div>
                <div>{status === "Present" ? "✅" : "❌"}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  ) : (
    <p>No attendance records found.</p>
  )
)}
            {/* Report Modal - Card Format */}

           {/* Report Modal */}
           {modalTitle === "report" && modalContent && Array.isArray(modalContent) && modalContent.length > 0 && (
  <>
  
    <div className="overflow-x-auto">
      <table className="min-w-full text-sm border">
        <thead className="bg-gray-100 text-gray-600">
          <tr>
            <th className="px-2 py-2 border">Sr.No</th>
            <th className="px-2 py-2 border">Date</th>
            <th className="px-2 py-2 border">Topic</th>
            <th className="px-2 py-2 border">Description</th>
          </tr>
        </thead>
        <tbody>
          {modalContent && modalContent?.map((report, idx) => (
            <tr key={idx} className="hover:bg-gray-50">
              <td className="px-2 py-2 border" align="center">{idx + 1}</td>
              <td className="px-2 py-2 border" align="center">{report.date}</td>
              <td className="px-2 py-2 border" align="center">{report.topic}</td>
              <td className="px-2 py-2 border" align="center">{report.description}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </>
)}

          
          </div>
        </div>
      </Modal>

      <Modal
  open={editModalOpen}
  onClose={() => setEditModalOpen(false)}
  className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
>
  <div className="bg-white rounded-lg shadow-lg w-full max-w-2xl">
    <div className="flex items-center justify-between px-4 pt-2 pb-2 border-b">
      <h2 className="text-xl font-semibold">Edit Student</h2>
      <button
        className="p-2 rounded-full hover:bg-gray-200"
        onClick={() => setEditModalOpen(false)}
      >
        &#10005;
      </button>
    </div>

    <div className="px-4 py-4 grid grid-cols-1 md:grid-cols-2 gap-4">
      <Input
        id="name"
        name="name"
        label="Name"
        placeholder="Enter your full name"
        value={editStudent.name}
        onChange={(e) => setEditStudent({ ...editStudent, name: e.target.value })}
      />

      <Input
        id="email"
        name="email"
        type="email"
        label="Email"
        placeholder="Enter your email"
        value={editStudent.email}
        onChange={(e) => setEditStudent({ ...editStudent, email: e.target.value })}
      />

      <Input
        id="phone"
        name="phone"
        type="tel"
        label="Phone"
        placeholder="Enter phone number"
        value={editStudent.phone}
        onChange={(e) => setEditStudent({ ...editStudent, phone: e.target.value })}
      />

      <Dropdown
        id="college"
        name="college"
        label="College"
        value={editStudent.college}
        onChange={(e) => setEditStudent({ ...editStudent, college: e.target.value })}
        options={colleges || []}
      />

      <Dropdown
        id="year"
        name="year"
        label="Year"
        value={editStudent.year}
        onChange={(e) => setEditStudent({ ...editStudent, year: e.target.value })}
        options={[
          { _id: "2022", name: "2022" },
          { _id: "2023", name: "2023" },
          { _id: "2024", name: "2024" },
          { _id: "2025", name: "2025" },
        ]}
      />

      <Dropdown
        id="branch"
        name="branch"
        label="Branch"
        value={editStudent.branch}
        onChange={(e) => setEditStudent({ ...editStudent, branch: e.target.value })}
        options={[
          { _id: "IT", name: "IT" },
          { _id: "CS", name: "CS" },
          { _id: "Other", name: "Other" },
        ]}
      />

      <Dropdown
        id="language"
        name="language"
        label="Course"
        value={editStudent.language}
        onChange={(e) => setEditStudent({ ...editStudent, language: e.target.value })}
        options={[
          { _id: "Java Fullstack", name: "Java Fullstack" },
          { _id: "Python Fullstack", name: "Python Fullstack" },
          { _id: "MERN Stack", name: "MERN Stack" },
          { _id: "Web Designing", name: "Web Designing" },
          { _id: "UI/UX", name: "UI/UX" },
          { _id: ".NET Fullstack", name: ".NET Fullstack" },
          { _id: "PHP Fullstack", name: "PHP Fullstack" },
          { _id: "Software Testing", name: "Software Testing" },
          { _id: "Data Analysis", name: "Data Analysis" },
          { _id: "Data Scientist", name: "Data Scientist" },
          { _id: "C & C++", name: "C & C++" },
          { _id: "AWS", name: "AWS" },
          { _id: "DevOps with AWS", name: "DevOps with AWS" },
        ]}
      />
    </div>

    <div className="text-right px-4 py-2 border-t">
      <button
        className="bg-blue-500 text-white px-6 py-2 rounded hover:bg-blue-600"
        onClick={handleEditSubmit}
      >
        Save Changes
      </button>
    </div>
  </div>
</Modal>




    </div>
  );
}
